import React, { Component } from 'react';

export class Form extends Component {
    displayName = Form.name

    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
    }

    submit(e) {
        e.preventDefault();
        var formHasError = false;

        this.props.children.forEach((item, index) => {
            if (item.ref != null) {
                if (!item.ref.current.checkForm()) {
                    formHasError = true
                }
            }
        })

        if (!formHasError) {
            this.props.onSubmit();
        }
    }

    render() {
        return (
            <form className={this.props.className} onSubmit={this.submit}>
                {
                    this.props.children.map((item, index) => {
                        return item;
                    })
                }
            </form>
        );
    }
}

Form.defaultProps = {
    onSubmit: () => { },
    className: ""
}


// WEBPACK FOOTER //
// ./src/components/Form.js